import React, { Component } from 'react'
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import { Card } from '../../../components/Card/Card'
import { FormInputs } from '../../../components/FormInputs/FormInputs'
import Button from '../../../components/CustomButton/CustomButton'
import { firebaseDb as db } from '../../../firebase'
import { connect } from 'react-redux'

class UserProfile extends Component {
  componentDidMount () {
    this.props.changeActiveCalendar(null)
    if (this.props.activeCompany) {
      db.doc('companies/' + this.props.activeCompany)
        .get()
        .then(querySnapshot => {
          let data = querySnapshot.data()
          document.getElementById('name').value = data.name
        })
        .catch(error => {
          console.log('error', error)
          this.notificationOpen('error', error)
        })
    }
  }

  notificationOpen = (type, errorMessage = '') => {
    if (type === 'success') {
      this.props.notificationOpen('tr', 'pe-7s-check', 'success', 'saved')
    } else if (type === 'error') {
      const message = 'not saved! Error: ' + errorMessage
      this.props.notificationOpen('tr', 'pe-7s-close-circle', 'error', message)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.activeCompany) {
      db.doc('companies/' + nextProps.activeCompany)
        .get()
        .then(querySnapshot => {
          let data = querySnapshot.data()
          document.getElementById('name').value = data.name
        })
        .catch(error => {
          console.log('error', error)
          this.notificationOpen('error', error)
        })
    }
  }

  render () {
    return (
      <div className='content'>
        <span style={{ color: 'red' }}>NOTE: THIS COMPONENT IS STATIC, change doesn't take an affect</span>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title='Edit Account'
                content={
                  <form>
                    <FormInputs
                      ncols={['col-md-5', 'col-md-3', 'col-md-4']}
                      proprieties={[
                        {
                          label: 'Company (disabled)',
                          type: 'text',
                          bsClass: 'form-control',
                          id: 'name',
                          name: 'name',
                          placeholder: 'Company',
                          defaultValue: 'Creative Code Inc.',
                          disabled: true
                        },
                        {
                          label: 'Username',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'Username',
                          defaultValue: 'michael23'
                        },
                        {
                          label: 'Email address',
                          type: 'email',
                          bsClass: 'form-control',
                          placeholder: 'Email'
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={['col-md-6', 'col-md-6']}
                      proprieties={[
                        {
                          label: 'First name',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'First name',
                          defaultValue: 'Mike'
                        },
                        {
                          label: 'Last name',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'Last name',
                          defaultValue: 'Andrew'
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={['col-md-12']}
                      proprieties={[
                        {
                          label: 'Adress',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'Home Adress',
                          defaultValue: 'Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09'
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={['col-md-4', 'col-md-4', 'col-md-4']}
                      proprieties={[
                        {
                          label: 'City',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'City',
                          defaultValue: 'Mike'
                        },
                        {
                          label: 'Country',
                          type: 'text',
                          bsClass: 'form-control',
                          placeholder: 'Country',
                          defaultValue: 'Andrew'
                        },
                        {
                          label: 'Postal Code',
                          type: 'number',
                          bsClass: 'form-control',
                          placeholder: 'ZIP Code'
                        }
                      ]}
                    />

                    <Row>
                      <Col md={12}>
                        <FormGroup controlId='formControlsTextarea'>
                          <ControlLabel>About Me</ControlLabel>
                          <FormControl
                            rows='5'
                            componentClass='textarea'
                            bsClass='form-control'
                            placeholder='Here can be your description'
                            defaultValue="Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo."
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button bsStyle='info' pullRight fill type='submit'>
                      Update Profile
                    </Button>
                    <div className='clearfix' />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeCalendar: state.activeCalendar,
    activeCompany: state.activeCompany
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeActiveCompany: activeCompany => dispatch({ type: 'CHANGE_ACTIVE_COMPANY', value: activeCompany }),
    changeActiveCalendar: activeCalendar => dispatch({ type: 'CHANGE_ACTIVE_CALENDAR', value: activeCalendar })
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile)
